import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class PdpRegisterAsBusinessApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.PDPRegisterAsBusinessInteraction;

  constructor(private label: string) {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Interaction,
      label: this.label
    };
  }
}
